<template>
  <div class="modalUser">
    <b-modal id="modalFolderMoveTo" ref="modalFolderMoveTo" modal-class="modal-no-border modal-moveTo modal-radius top-mb" centered no-close-on-backdrop>
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100">
          <div class="btn-closeModal" @click="hideModalMoveTo">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/>
            </svg>
          </div>
        </div>
      </template>
      <div class="modalUser--main files">
        <ul class="folder-move scroll-bar">
          <li class="folder-back folder-li">
            <div class="folder-list">
              <div>
                <img src="@img/icon/left-arrow.svg" alt="" class="img-sign" v-if="metadataMove.folder_name" @click="backFolder(metadataMove.folder_parent_id)">
                <span>{{truncate(metadataMove.folder_name? metadataMove.folder_name: 'ファイル一覧',15,'...')}}</span>
              </div>
            </div>
          </li>
          <li class="folder-li" v-for="(folder,index) in folderMove" v-bind:key="index" @dblclick="moveFile(folder.id)">
            <div class="folder-list">
              <div>
                <img src="@img/folder.svg" alt="" class="img-sign">
                <span>{{truncate(folder.name,15,'...')}}</span>
              </div>
              <img src="@img/icon/icon-down-grey.svg" class="img-next" @click="moveFile(folder.id)"/>
            </div>
          </li>
        </ul>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <div class="d-flex justify-content-center btn-reverse">
            <button
              class="btn btn-rounder btn-secondary btn-contact w-100 btn-basic mr-30"
              type="button" @click="hideModalMoveTo">キャンセル
            </button>
            <button
              class="btn btn-rounder btn-primary btn-contact w-100 btn-basic"
              type="button" @click="saveMove" :disabled="hideClick()">移動
            </button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {BModal, VBModal} from 'bootstrap-vue'
import {mapState} from 'vuex'
export default {
  name: 'FileMoveTo',
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  data () {
    return {
      modalShow: false,
      folder_id: ''
    }
  },
  props: {
    idMove: '',
    folder_show_id: ''
  },
  methods: {
    hideClick () {
      return this.folder_id === '' || this.folder_id === this.folder_show_id
    },
    loadFile () {
      this.reloadFileAdmin(1)
    },
    showSuccess () {
      this.$emit('showSuccess')
    },
    back () {
      this.$emit('pageIndexBack')
    },
    showFailure () {
      this.$emit('showFailure')
    },
    saveMove () {
      this.$store.dispatch('adminFolder/moveFile', {id: this.idMove,
        folder_id: this.folder_id,
        modal: this.hideModalMoveTo,
        show: this.showSuccess,
        showFailure: this.showFailure,
        load: this.loadFile,
        back: this.back,
        company_id: this.$route.params.id})
    },
    moveFile (id) {
      this.folder_id = id
      this.$store.commit('adminFolder/CHANGE_FOLDER_MOVE', '')
      this.$store.dispatch('adminFolder/getFolderMove', {page_index: 1, id: id, company_id: this.$route.params.id})
    },
    backFolder (id) {
      this.folder_id = id
      this.$store.commit('adminFolder/CHANGE_FOLDER_MOVE', '')
      this.$store.dispatch('adminFolder/getFolderMove', {page_index: 1, id: id, company_id: this.$route.params.id})
    },
    hideModalMoveTo () {
      this.folder_id = ''
      this.$store.commit('adminFolder/CHANGE_FOLDER_MOVE', '')
      this.$store.commit('adminFolder/CHANGE_METADATA_MOVE', '')
      this.$refs['modalFolderMoveTo'].hide()
    }
  },
  computed: {
    ...mapState({
      folderMove: state => state.adminFolder.folderMove,
      metadataMove: state => state.adminFolder.metadataMove
    })
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/auth/listfile.scss";
  @import '@/assets/stylesheet/vendor/uploadfile.scss';
</style>



// WEBPACK FOOTER //
// src/components/Admin/FolderManagerment/FolderMoveTo.vue